export const META_TITLE_CONTENT = 'RadMELDER Baden-Württemberg';
const META_DESCRIPTION_CONTENT =
  'Mit dem RadMELDER BW Mängel und Hindernisse auf Radwegen in Baden-Württemberg direkt online melden – für mehr Sicherheit im Radverkehr.';

export const META_DESCRIPTION = { name: 'description', content: META_DESCRIPTION_CONTENT };
export const META_ROBOTS_NOINDEX = { name: 'robots', content: 'noindex' };

export function makeMetaTitle(prefixes: string[]) {
  return { title: [...prefixes, META_TITLE_CONTENT].join(' | ') };
}
